<template>
    <div>
        <BaseDatatable :module="module" :apiurl="apiUrl" :fields="fields" :loaded="loaded"></BaseDatatable>
    </div>
</template>

<script>
import BaseDatatable from '../../core/BaseDatatable'
export default {
  name: 'CustomListModule',
  components: {BaseDatatable},
  props: ['apiUrl', 'fields', 'url', 'moduleName', 'loaded', 'module'],
  created: function () {
    this.$emit('updateTitle', this.moduleName + ' ' + this.$translate.t('List'))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/custom/CustomListModule.vue